import { ProductActions, EProductActions } from "../actions/product.actions";
import { initialProductState, IProductState } from "../states/product.state";

export const ProductReducers = (
  state = initialProductState,
  action: ProductActions
): IProductState => {
  switch (action.type) {
    case EProductActions.GetSingleProduct: {
      return {
        ...state,
        Product: null,
      };
    }
    case EProductActions.GetProduct: {
      return {
        ...state,
        Products: null,
      };
    }
    case EProductActions.GetAllProduct: {
      return {
        ...state,
        AllProducts: null,
      };
    }
    case EProductActions.GetProductSuccess: {
      return {
        ...state,
        Products: action.payload,
      };
    }
    case EProductActions.GetAllProductSuccess: {
      return {
        ...state,
        AllProducts: action.payload,
      };
    }
    case EProductActions.GetSingleProductSuccess: {
      return {
        ...state,
        Product: action.payload,
      };
    }

    default:
      return state;
  }
};
